import {
  PrimaryRegularButton,
  SecondaryRegularButton
} from 'components/ReusableComponents/Button/RegularButtons'
import PublishBubble from 'features/PublishCampaign/PublishBubble'

import styles from './CompareAndPublish.module.scss'

const CompareAndPublish = ({
  previousContent,
  newContent,
  usedBy,
  onCancel,
  onConfirm
}) => (
  <div className={styles.wrapper}>
    <div className={styles.mainWrapper}>
      <p className={styles.mainTitle}>Content to update</p>
      <div className={styles.main}>
        <div className={styles.bubbleHolder}>
          <PublishBubble isPrevious text={previousContent} />
          <PublishBubble text={newContent} />
        </div>
        <div className={styles.buttonHolder}>
          <SecondaryRegularButton onClick={onCancel}>Cancel</SecondaryRegularButton>
          <PrimaryRegularButton onClick={onConfirm}>Publish</PrimaryRegularButton>
        </div>
      </div>
    </div>
    <div className={styles.sidebar}>
      <p className={styles.sidebarTitle}>Will be applied to {usedBy.length} hotels</p>
      {usedBy.map(item => (
        <p className={styles.listItem} key={item.id}>
          {item.hotelName}
        </p>
      ))}
    </div>
  </div>
)

export default CompareAndPublish
